import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectContactEmail, selectLoaded, selectLoading, selectSchool } from '../selectors/school.selector';
import { schoolActions } from '../actions/school.actions';

@Injectable({
    providedIn: 'root',
})
export class SchoolFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((school) => school !== null));
    readonly loading$ = this.store.select(selectLoading).pipe(filter((data) => data !== null));
    readonly school$ = this.store.select(selectSchool);
    readonly schoolNonNullable$ = this.store.select(selectSchool).pipe(filter((school) => school !== null));

    readonly school = this.store.selectSignal(selectSchool);
    readonly contactEmail = this.store.selectSignal(selectContactEmail);

    readonly contactEmail$ = this.store.select(selectContactEmail);

    getSchool(id: string): void {
        this.store.dispatch(schoolActions.getSchool({ id }));
    }

    getContactEmail(): void {
        this.store.dispatch(schoolActions.getContactEmail());
    }

    clear(): void {
        this.store.dispatch(schoolActions.clear());
    }
}
